<template>
    <div class="active-filters" v-if="Object.keys(activeFilters).length !== 0">
        <div class="page-filter-header">
            <div class="position-relative row">
                <div class="col-12">
                    <h4 class="m-0 d-inline-block color-brand--secondary" >
                        Actieve filters
                    </h4>
                    <small class="cursor-pointer text-right position-absolute top-3 right-15" @click="removeActiveFilters();">
                        Wis alle filters
                    </small>
                </div>
            </div>

            <div class="active-filter-content">
                <div class="mb-3" v-for="item in activeFilters">
                    <div class="row">
                        <div class="col-8">
                            <strong>{{item.label}}:</strong>
                        </div>
                        <div class="col-4 text-right">
                            <i class="fas fa-times cursor-pointer" @click="removeActiveFilters(item.id);"></i>
                        </div>
                    </div>

                    <span class="small">
                        <span v-for="(value, index) in item.values">
                            {{value.label}}<span v-if="(item.values.length - 1) !== index">, </span>

                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


    export default {
        data() {
            return {
                activeFilters: {}
            };
        },
        mounted() {
            VueEvents.$on('loaded_filters', filters => {
                this.setActiveFilters(filters);
            });

        },
        methods: {

            setActiveFilters(filters) {
                this.activeFilters = {};
                for(let filterKey in filters) {
                    for(let filterValue of filters[filterKey].values) {

                        if(typeof filters[filterKey].data.hide !== 'undefined' && true === filters[filterKey].data.hide) {
                            continue;
                        }

                        if(filterValue.selected === false) {
                            continue;
                        }

                        if(typeof this.activeFilters[filters[filterKey].id] === 'undefined') {
                            this.activeFilters[filters[filterKey].id] =
                                {
                                    'id': filters[filterKey].id,
                                    'label': filters[filterKey].label,
                                    'data': filters[filterKey].data,
                                    'values': []
                                };

                        }
                        this.activeFilters[filters[filterKey].id].values.push(filterValue);

                        if(filterValue.children.values.length) {
                            for(let filterChildValue of filterValue.children.values) {
                                if(filterChildValue.selected === false) {
                                    continue;
                                }
                                if(typeof this.activeFilters[filterValue.children.id] === 'undefined') {
                                    this.activeFilters[filterValue.children.id] =
                                        {
                                            'id': filterValue.children.id,
                                            'label': filterValue.children.label,
                                            'data': filterValue.children.data,
                                            'values': []
                                        };

                                }
                                this.activeFilters[filterValue.children.id].values.push(filterChildValue);
                            }
                        }

                    }
                }
            },

            removeActiveFilters(id) {
                if(id) {
                    MrMovie.pageFilter.removeFilters(id);
                } else {
                    MrMovie.pageFilter.removeFilters();
                }

                MrMovie.pageFilter.updateQueryParams();
                MrMovie.pageFilter.filter();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// resources/js/components/ActiveFilters.vue